'use client';

import { useTranslations } from 'use-intl';

import { useUsabilitySidebarState } from './project-usability-recording.hooks';
import { useUsabilityResponseContext } from './project-usability-response-context';
import ProjectUsabilityResponseSaving from './project-usability-response-saving';
import ProjectUsabilityResponseWrappingUp from './project-usability-response-wrapping-up';
import ProjectUsabilitySpeechPrompt from './project-usability-speech-prompt';
import ProjectUsabilityTimeoutCountdown from './project-usability-timeout-countdown';
import ProjectUsabilityTimeoutOverlay from './project-usability-timeout-overlay';

export default function ProjectUsabilityResponseOverlays() {
  const t = useTranslations('Usability');

  const { session, voice } = useUsabilityResponseContext();

  const { isOpen: isSidebarOpen } = useUsabilitySidebarState();

  const {
    recordingError,
    showSubmitted,
    currentRemainingTime,
    isRecording,
    isPausedByTimeout,
    showTimeoutOverlay,
    handleResumeRecording,
    isScreenShareMuted,
    isFinalizingRecording,
    finalizationStarted,
    hasUrlOrTask,
    uploadProgress,
    isUploadStalled,
    retryUpload,
  } = session;
  const { showPrompt, isFadingOut, onSpeechPromptClose, ttsHasDrained } = voice;

  return (
    <>
      {recordingError && (
        <div className='fixed top-2 left-2 z-50 rounded-sm bg-yellow-600 px-3 py-1 text-xs text-white shadow-sm'>
          {recordingError}
        </div>
      )}

      {!showSubmitted && (
        <>
          <ProjectUsabilityTimeoutCountdown
            remainingTime={currentRemainingTime}
            isVisible={isRecording && !isPausedByTimeout}
          />

          <ProjectUsabilityTimeoutOverlay
            isVisible={showTimeoutOverlay}
            onResume={handleResumeRecording}
          />

          <ProjectUsabilityTimeoutOverlay
            isVisible={isScreenShareMuted}
            onResume={() => window.location.reload()}
            title={t('screenSharePausedTitle')}
            message={t('screenSharePausedMessage')}
            buttonText={t('screenSharePausedButton')}
          />

          <ProjectUsabilitySpeechPrompt
            isVisible={showPrompt}
            isFadingOut={isFadingOut}
            isSidebarOpen={isSidebarOpen}
            onClose={onSpeechPromptClose}
          />
        </>
      )}

      {ttsHasDrained &&
        !isFinalizingRecording &&
        !finalizationStarted &&
        hasUrlOrTask && <ProjectUsabilityResponseWrappingUp />}

      {ttsHasDrained && isFinalizingRecording && (
        <ProjectUsabilityResponseSaving
          uploadProgress={uploadProgress}
          isStalled={isUploadStalled}
          onRetry={retryUpload}
        />
      )}
    </>
  );
}
